import { CopyFromDprModalComponent } from './copy-from-dpr-modal/copy-from-dpr-modal.component';
import { DprActivitiesDialogModeComponent } from './dpr-activities-dialog-mode/dpr-activities-dialog-mode.component';
import { DprAttachmentsComponent } from './dpr-attachments/dpr-attachments.component';
import { DprDetailsCopyActionModalComponent } from './dpr-details-copy-action-modal/dpr-details-copy-action-modal.component';
import { DprDetailsHeaderComponent } from './dpr-details-header/dpr-details-header.component';
import { DprEditActivityDialogEditComponent } from './dpr-edit-activity-dialog-edit/dpr-edit-activity-dialog-edit.component';
import { DprEditActivitySubActivitiesGridComponent } from './dpr-edit-activity-subactivities-grid/dpr-edit-activity-subactivities-grid.component';
import { DprAttachmentsGridComponent } from './dpr-attachments-grid/dpr-attachments-grid.component';
import { DprEditActivityCustomDataGridComponent } from './dpr-edit-activity-custom-data-grid/dpr-edit-activity-custom-data-grid.component';
import { DprWeatherRegistrationsGridComponent } from './dpr-weather-registrations-grid/dpr-weather-registrations-grid.component';
import { DprActivitiesGridComponent } from './dpr-activities-grid/dpr-activities-grid.component';
import { DprConsumablesGridComponent } from './dpr-consumables-grid/dpr-consumables-grid.component';
import { DprCommentComponent } from './dpr-comment/dpr-comment.component';
import { DprHseRegistrationsGridComponent } from './dpr-hse-registrations-grid/dpr-hse-registrations-grid.component';
import { DprPersonnelRegistrationsGridComponent } from './dpr-personnel-registrations-grid/dpr-personnel-registrations-grid.component';
import { DprProgressGridComponent } from './dpr-progress-grid/dpr-progress-grid.component';
import { DprProgressWithoutTargetGridComponent } from './dpr-progress-without-target-grid/dpr-progress-without-target-grid.component';
import { DprForecastActivitiesGridComponent } from './dpr-forecast-activities-grid/dpr-forecast-activities-grid.component';
import { DprCommentAttachmentsComponent } from './dpr-comment-attachments/dpr-comment-attachments.component';
import { DprStatusTrackerGridComponent } from './dpr-status-tracker-grid/dpr-status-tracker-grid.component';
import { DprTableOfColumnsRegistrationsGridComponent } from './dpr-table-of-columns-registrations-grid/dpr-table-of-columns-registrations-grid.component';
import { DprCopyActivityDialogEditComponent } from './dpr-copy-activity-dialog-edit/dpr-copy-activity-dialog-edit.component';
import { NavigationSelectComponent } from './navigation-select/navigation-select.component';
import { DprImportActivitiesDialogComponent } from './dpr-import-activities-dialog/dpr-import-activities-dialog.component';

export {
  DprDetailsHeaderComponent,
  DprActivitiesGridComponent,
  CopyFromDprModalComponent,
  DprEditActivityDialogEditComponent,
  DprEditActivityCustomDataGridComponent,
  DprDetailsCopyActionModalComponent,
  DprEditActivitySubActivitiesGridComponent,
  DprAttachmentsComponent,
  DprAttachmentsGridComponent,
  DprConsumablesGridComponent,
  DprWeatherRegistrationsGridComponent,
  DprHseRegistrationsGridComponent,
  DprCommentComponent,
  DprPersonnelRegistrationsGridComponent,
  DprCommentAttachmentsComponent,
  DprProgressGridComponent,
  DprProgressWithoutTargetGridComponent,
  DprForecastActivitiesGridComponent,
  DprStatusTrackerGridComponent,
  DprTableOfColumnsRegistrationsGridComponent,
  DprCopyActivityDialogEditComponent,
  NavigationSelectComponent,
  DprActivitiesDialogModeComponent,
  DprImportActivitiesDialogComponent,
};

export const components = [
  DprDetailsHeaderComponent,
  DprActivitiesGridComponent,
  CopyFromDprModalComponent,
  DprEditActivityDialogEditComponent,
  DprEditActivityCustomDataGridComponent,
  DprDetailsCopyActionModalComponent,
  DprEditActivitySubActivitiesGridComponent,
  DprAttachmentsComponent,
  DprAttachmentsGridComponent,
  DprConsumablesGridComponent,
  DprWeatherRegistrationsGridComponent,
  DprHseRegistrationsGridComponent,
  DprCommentComponent,
  DprPersonnelRegistrationsGridComponent,
  DprCommentAttachmentsComponent,
  DprProgressGridComponent,
  DprProgressWithoutTargetGridComponent,
  DprForecastActivitiesGridComponent,
  DprStatusTrackerGridComponent,
  DprTableOfColumnsRegistrationsGridComponent,
  DprCopyActivityDialogEditComponent,
  NavigationSelectComponent,
  DprActivitiesDialogModeComponent,
  DprImportActivitiesDialogComponent,
];
